import _ from 'lodash'

let listUtil = {}

const roundAccurately = (number, decimalPlaces) => Number(Math.round(number + 'e' + decimalPlaces) + 'e-' + decimalPlaces)

listUtil.addRatioToObject = function (row, output, val, val2, percentage = false) {
  let a = row[val]
  let b = row[val2]
  if ((!a) || (!b)) {
    return null
  }
  if (b === 0) {
    return null
  }
  let value = a / b
  if (percentage) {
    value = roundAccurately(value * 100, 1)
  } else {
    value = roundAccurately(value, 2)
  }
  row[output] = value
}

listUtil.addProductToObject = function (row, output, val, val2, percentage = false) {
  let a = row[val]
  let b = row[val2]
  if ((!a) || (!b)) {
    return null
  }
  let value = a * b
  if (percentage) {
    value = roundAccurately(value / 100, 1)
  } else {
    value = roundAccurately(value, 2)
  }
  row[output] = value
}

listUtil.addTableHeaderRow = function (result, key) {
  result.push({ text: _.startCase(key), value: key })
}

export default listUtil
